var _circle, _polygon, _path, _circle2, _circle3, _path2, _rect, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DisconnectMainPlug50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#1565c0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#fff",
    points: "20,35 27,35 27,37 30,34 27,31 27,33 20,33"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21,15H11c-1.105,0-2,0.895-2,2v10c0,1.105,0.895,2,2,2h10c1.105,0,2-0.895,2-2V17 C23,15.895,22.105,15,21,15z M16,27c-2.761,0-5-2.239-5-5s2.239-5,5-5s5,2.239,5,5S18.761,27,16,27z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 20,
    r: 1,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 24,
    r: 1,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38,22c0,2.761-2.239,5-5,5c-1.496,0-2,0-2,0V17c3.239,0,0.239,0,2,0C35.761,17,38,19.239,38,22z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 12,
    x: 30,
    y: 16,
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,20h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h5V20z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31,26h-5c-0.553,0-1-0.447-1-1s0.447-1,1-1h5V26z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 2,
    x: 34,
    y: 21,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DisconnectMainPlug50);
export default __webpack_public_path__ + "static/media/icons8-disconnect-main-plug-50.c03fcb998de1d0aca8784892b3490fc7.svg";
export { ForwardRef as ReactComponent };